import React, { useEffect, useState, useRef, useContext } from "react";
import "../styles/bills.css";
import "../App.css";
import { http } from "../auth";
import { Modal, Col, Row, Button, Form, Spinner, Overlay, Popover, DropdownButton, Dropdown } from "react-bootstrap";
import Select from "react-select";
import { IoDocumentText } from "react-icons/io5";
import { IoAlertCircleOutline } from "react-icons/io5";
import { LiaCheckCircleSolid } from "react-icons/lia";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { useThemeManager } from "../Hooks/ThemeManager";
import { RxCross2 } from "react-icons/rx";

function RetencionModal({ onHide, onUpdate, show, mode, data }) {

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onHidden = () => {
    onHide();
    reset();
    setTipo(null);
    setFileBase64(null);
    setFileName("");
  };

  const token = localStorage.getItem("token");
  const [tipo, setTipo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileBase64, setFileBase64] = useState(null);
  const [fileName, setFileName] = useState("");
  const [mimetype, setMimetype] = useState("");
  const [loadingIcon, setLoadingIcon] = useState("");
  const { themeColors } = useThemeManager();
  const [selectedRowData, setSelectedRowData] = useState([]);
  const convertToDatetime = (date) => (date ? `${date}T00:00:00` : null);

  const retenciones = data?.retenciones || [];
  const estadoPorTipo = retenciones.reduce((acc, retencion) => {
    acc[retencion.tipo] = retencion.estado;
    return acc;
  }, {});

  const allOptions = ["iva", "islr", "timbres", "municipal"];
  const options = retenciones
    .filter((retencion) => retencion.estado !== "inactivo")
    .map((retencion) => {
      const tipo = retencion.tipo;
      return {
        valor: tipo,
        label: (
          <div className="d-flex align-items-center fondo-blanco">
            {retencion.estado && retencion.estado !== "pendiente" && retencion.estado !== "sin cargar" ? (
              <LiaCheckCircleSolid size={20} style={{ color: "#7ed45f" }} className="me-2" />
            ) : (
              <IoAlertCircleOutline size={20} style={{ color: "#c66d2d" }} className="me-2" />
            )}
            {`Retención ${(tipo || "").toUpperCase()}`}
          </div>
        ),
      };
    });
  const selectRetencion = (selected) => {
    setTipo(selected);
  };

  const formatFecha = (fechaISO) => {
    if (!fechaISO) return "Fecha no válida";
    const date = new Date(fechaISO);
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const retencionSeleccionada = retenciones.find((ret) => ret.tipo === tipo?.valor);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFileBase64(reader.result);
        setFileName(file.name);
        setMimetype(file.type);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleView = async (id) => {
    setLoadingIcon(true);
    try {
      const response = await http.get(`/intranet-j/retenciones/${id}/ver`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "arraybuffer",
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      setLoadingIcon(false);
      if (!newWindow) {
        throw new Error("No se pudo abrir una nueva ventana para ver la factura.");
      }
    } catch (error) {
      setLoadingIcon(false);
      console.error("Error al ver la factura:", error);
    }
  };

  const handleViewDocument = async (id) => {
    setLoadingIcon(true);
    try {
      const response = await http.get(`/intranet-j/documento-descargar/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "arraybuffer",
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error al ver el documento:", error);
    } finally {
      setLoadingIcon(false);
    }
  };

  const onSubmit = async (formData) => {
    setLoading(true);

    if (!fileBase64) {
      toast.error("Falta subir el documento de la retención.");
      setLoading(false);
      return;
    }

    formData.id_doc = data?.id;
    formData.fecha_emi = convertToDatetime(formData.fecha_emi);
    formData.tipo = tipo?.valor;
    formData.nro_comprobante = formData.nro_comprobante || null;
    formData.mimetype = mimetype;
    formData.file = fileBase64;


    http
      .post(`/intranet-j/retenciones`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        toast.success("Retención cargada de forma exitosa");
        onUpdate?.();
        onHidden();
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error al cargar retención:", error);
        if (error?.response?.status === 400) {
          toast.error(error?.response?.data?.detail || "Solicitud inválida.");
        } else {
          toast.error(error?.message || "Hubo un problema al cargar la retención.");
        }
      });
  };

  const handleAnular = async (id) => {
    const confirmar = window.confirm("¿Está seguro de que desea anular esta retención?");

    if (!confirmar) {
      return;
    }

    setLoadingIcon(true);
    try {
      const response = await http(`/intranet-j/retenciones/${id}/anular`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Documento anulado");
    } catch (error) {
      console.error("Error al conectar con el servidor:", error);
      toast.error("Hubo un problema al intentar anular el documento");
    } finally {
      setLoadingIcon(false);
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "transparent" : state.isFocused ? "transparent" : "transparent",
      color: 'var(--primary-color)',
      color: state.isDisabled ? "#ccc" : 'var(--primary-color)',
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      borderBottom: "1px solid #e8efff",
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      border: "1px solid #e8efff",
      padding: "4px",
      backgroundColor: "var(--fondoBlanco)",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--primary-color)',
      padding: "4px",
      backgroundColor: "var(--fondoBlanco)",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'var(--secondary-color)',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "var(--fondoBlanco)",
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      backgroundColor: "var(--fondoBlanco)",
      padding: 0,
    }),
    input: (provided) => ({
      ...provided,
      color: 'var(--secondary-color)',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'var(--primary-color)',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: 'var(--primary-color)',
    }),
  };

  const getStatusStyle = (estado) => {
    let bgColor;
    let textColor = "white";

    switch (estado) {
      case "completada":
      case "faltan retenciones":
        bgColor = "#063b82";
        break;
      case "por pagar":
        bgColor = "#0f73fd";
        break;
      case "sin retenciones":
      case "retenciones pendientes":
        bgColor = "#d12828";
        break;
      case "por validar":
        bgColor = "#facb0c";
        textColor = "#310a0a";
        break;
      case "verificada":
        bgColor = "#5DBE04";
        textColor = "#fff";
        break;
      default:
        bgColor = "#f0f0f0";
        textColor = "#000";
    }

    return { backgroundColor: bgColor, color: textColor };
  };

  useEffect(() => {
    if (show) {
      setTipo(options.length > 0 ? options[0] : null);
      reset({ fecha_emi: new Date().toISOString().split("T")[0] });
      setFileBase64(null);
      setFileName("");
    }
  }, [show, reset]);

  return (
    <Modal show={show} onHide={onHidden} centered>
      <div className="d-flex justify-content-end p-3">
        <button onClick={onHidden} className="eliminarBG">
          <RxCross2 className="color-primary" style={{ fontSize: 35 }} />
        </button>
      </div>
      <div className="pb-5 ps-5 pe-5 modal-retencion">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h3 className="title-color color-secondary" style={{ fontWeight: 600 }}>
              Retenciones
            </h3>
            <p className="mb-0 title-color color-secondary">
              Gestione los documentos asociados a la factura
            </p>
          </div>
        </div>
        {data?.estado === "completada" && retenciones.length === 0 ? (
          <>
            <div className="tipo-retencion">
              <div className="line-retencion"></div>
              <span className="font-retencion">Retención cargada</span>
              <div className="line-retencion"></div>
            </div>
            <div className="retencion-iva">
              <Row className="w-100 m-0 gy-2">
                <Col xs={7} md={4} className="d-flex flex-column align-items-center justify-content-center">
                  <span><IoDocumentText className="icon-color-retencion" /> Ref. {data?.nro_fac}</span>
                  <div className="status-iva mt-1" style={getStatusStyle("completada")}>
                    <div style={{ fontWeight: "bold" }}>Completada</div>
                  </div>
                </Col>
                <Col xs={5} md={4} className="font-size-monto">
                  <div className="vertical-line me-3"></div>
                  <div className="text-center">
                    <span>Emisión:</span>
                    <div>{formatFecha(data?.fecha_emi)}</div>
                  </div>
                </Col>
                <Col xs={12} md={4} className="p-0">
                  <div className="base color-base">
                    <span className="size-base">Base</span>
                    <span className="vertical-div"></span>
                    <span className="font-amount">{data?.total_bruto} Bs.</span>
                  </div>
                  <div className="base color-monto mt-1">
                    <span className="size-base">Monto</span>
                    <span className="vertical-div"></span>
                    <span className="font-amount">{data?.total_iva} Bs.</span>
                  </div>
                </Col>
              </Row>
            </div>
            <button className="btn-view mt-2" onClick={() => handleViewDocument(data?.id)}>
              {loadingIcon ? <div className="spinner color-spinner"></div> : <span className="text-dark-mode">Ver el documento cargado</span>}
            </button>
          </>
        ) : (
          <>
        {/* Tipo de retención */}
        <Form.Group className="mb-2">
          <Form.Label>Tipo de retención:</Form.Label>
          <Select
            options={options}
            value={tipo}
            className="retencion"
            placeholder="Seleccione..."
            onChange={selectRetencion}
            isSearchable={false}
            styles={customStyles}
          />
        </Form.Group>
        {/* Retención seleccionada */}
        {retencionSeleccionada ? (
          retencionSeleccionada.estado === "sin cargar" ? (
            <div>
              <form onSubmit={handleSubmit(onSubmit)}>
                {/* Número de comprobante */}
                <Form.Group className="mb-2">
                  <Form.Label className="label-retencion">Número de comprobante:</Form.Label>
                  <input
                    type="number"
                    placeholder="Ingresar número de comprobante"
                    className="select-retencion"
                    {...register("nro_comprobante")}
                  />
                </Form.Group>

                {/* Fecha de retención y monto */}
                <Row className="g-2">
                  <Col xs={12} sm={5}>
                    <Form.Group className="mb-2">
                      <Form.Label className="label-retencion">Fecha de la retención:</Form.Label>
                      <input
                        type="date"
                        className="select-retencion color-primary"
                        lang="es"
                        {...register("fecha_emi", {
                          required: "La fecha es obligatoria",
                        })}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={7}>
                    <Form.Group className="mb-2">
                      <Form.Label className="label-retencion">Monto:</Form.Label>
                      <input
                        type="number"
                        disabled
                        placeholder={retencionSeleccionada.monto + " Bs"}
                        className="select-retencion disabled"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Carga de documento */}
                <Form.Group>
                  <Form.Label>Documento de retención</Form.Label>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label htmlFor="file-upload">
                      <div
                        className="title-color"
                        style={{
                          border: "2px dashed #e8efff",
                          padding: "15px",
                          textAlign: "center",
                          borderRadius: "8px",
                          cursor: "pointer",
                          height: "100px",
                        }}
                      >
                        {fileName || "Haga clic para cargar el documento"}
                      </div>
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".png, .jpg, .jpeg, .pdf, .webp"
                    />
                  </div>
                </Form.Group>
                {/* Footer del Modal */}
                <Modal.Footer className="p-0 mt-3" style={{ borderTop: "none" }}>
                  <Button className="btn-retencion btn-cancelar" variant="secondary" onClick={onHide}>
                    Cancelar
                  </Button>
                  <Button type="submit" className="btn-retencion" variant="primary">
                    {loading ? <div className="spinner"></div> : <span>Confirmar</span>}
                  </Button>
                </Modal.Footer>
              </form>
            </div>
          ) : (
            <>
              <div className="tipo-retencion">
                <div className="line-retencion"></div>
                <span className="font-retencion">Retención cargada</span>
                <div className="line-retencion"></div>
              </div>

              {/* Detalles de la retención */}
              <div className="retencion-iva">
                <Row className="w-100 m-0 gy-2">
                  <Col xs={7} md={4} className="d-flex flex-column align-items-center justify-content-center">
                    <div className="vertical-align">
                      
                      <span><IoDocumentText className="icon-color-retencion" /> Ref. {retencionSeleccionada?.nro_comprobante}</span>
                    </div>
                    <div className="status-iva mt-1" style={getStatusStyle(retencionSeleccionada?.estado)}>
                      <div style={{ fontWeight: "bold" }}>
                        {retencionSeleccionada.estado.charAt(0).toUpperCase() + retencionSeleccionada?.estado.slice(1)}
                      </div>
                    </div>
                  </Col>
                  <Col xs={5} md={4} className="font-size-monto ">
                    <div className="vertical-line me-3"></div>
                    <div className="text-center">
                      <span>Emisión:</span>
                      <div>{formatFecha(retencionSeleccionada?.fecha_emi)}</div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}  className="p-0">
                    <div className="base color-base">
                      <span className="size-base">Base</span>
                      <span className="vertical-div"></span>
                      <span className="font-amount">{retencionSeleccionada.base} Bs.</span>
                    </div>
                    <div className="base color-monto mt-1">
                      <span className="size-base">Monto</span>
                      <span className="vertical-div"></span>
                      <span className="font-amount">{retencionSeleccionada.monto} Bs.</span>
                    </div>
                  </Col>
                </Row>
              </div>
              <button
                className="btn-anular mb-2 mt-2"
                onClick={() => handleAnular(data?.id)}
                disabled={retencionSeleccionada.estado === "aprobada"}
                style={{
                  cursor: retencionSeleccionada.estado === "aprobada" ? "not-allowed" : "pointer",
                  opacity: retencionSeleccionada.estado === "aprobada" ? 0.6 : 1,
                }}
              >
                Anular documento
              </button>
              <button className="btn-view" onClick={() => handleView(retencionSeleccionada?.id)}>
                {loadingIcon ? <div className="spinner color-spinner"></div> : <span className="text-dark-mode">Ver el documento cargado</span>}
              </button>
            </>
          )
        ) : (
          <></>
        )}
          </>
        )}
      </div>
    </Modal>
  )
}

export default RetencionModal